import {
  GET_CROSSSELL_START,
  GET_CROSSSELL_SUCCESS,
  GET_CROSSSELL_FAILURE,
  GET_CROSSSELL_RESET,
  GET_CITY_START,
  GET_CITY_SUCCESS,
  GET_CITY_FAILURE,
  GET_CITY_RESET,
  EXPORT_CROSS_SELL_REPORT,
  EXPORT_CROSS_SELL_REPORT_SUCCESS,
  EXPORT_CROSS_SELL_REPORT_FAILED,
} from "./actiontypes";

const initialState = {
  CrossSell: [],
  error: null,
  AddCrossSellLoading: false,
  CrossSellMsg: "",
  Lob: [],
  city: [],
  excelReport: [],
  isReportDownloaded: false,
};

const CrossSellReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CROSSSELL_START:
      return {
        ...state,
        AddCrossSellLoading: true,
        error: null,
      };

    case GET_CROSSSELL_SUCCESS:
      return {
        ...state,
        AddCrossSellLoading: false,
        CrossSell: action.payload?.cust_list || [],
      };

    case GET_CROSSSELL_FAILURE:
      return {
        ...state,
        AddCrossSellLoading: false,
        error: action.payload?.message || action.payload || "Failed to fetch",
      };

    case GET_CROSSSELL_RESET:
      return {
        ...state,
        CrossSell: [],
        error: null,
        AddCrossSellLoading: false,
        CrossSellMsg: "",
      };

    case GET_CITY_START:
      return {
        ...state,
      };

    case GET_CITY_SUCCESS:
      return {
        ...state,
        city: action.payload?.data || action.payload || [],
      };

    case GET_CITY_FAILURE:
      return {
        ...state,
      };

    case GET_CITY_RESET:
      return {
        ...state,
        city: [],
      };

    case EXPORT_CROSS_SELL_REPORT:
      return {
        ...state,
        AddCrossSellLoading: true,
      };

    case EXPORT_CROSS_SELL_REPORT_SUCCESS:
      return {
        ...state,
        AddCrossSellLoading: false,
        excelReport: action.payload || [],
        isReportDownloaded: true,
      };

    case EXPORT_CROSS_SELL_REPORT_FAILED:
      return {
        ...state,
        AddCrossSellLoading: false,
        error: action.payload?.message || action.payload || "Export failed",
      };

    default:
      return state;
  }
};

export default CrossSellReducer;